/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PublicFailureTypeVm,
    PublicFailureTypeVmFromJSON,
    PublicFailureTypeVmFromJSONTyped,
    PublicFailureTypeVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface PublicFailureTypeVmPaginatedSearchResponse
 */
export interface PublicFailureTypeVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<PublicFailureTypeVm>}
     * @memberof PublicFailureTypeVmPaginatedSearchResponse
     */
    items?: Array<PublicFailureTypeVm> | null;
    /**
     * 
     * @type {number}
     * @memberof PublicFailureTypeVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicFailureTypeVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicFailureTypeVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicFailureTypeVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicFailureTypeVmPaginatedSearchResponse
     */
    size?: number;
}

export function PublicFailureTypeVmPaginatedSearchResponseFromJSON(json: any): PublicFailureTypeVmPaginatedSearchResponse {
    return PublicFailureTypeVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function PublicFailureTypeVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicFailureTypeVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(PublicFailureTypeVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function PublicFailureTypeVmPaginatedSearchResponseToJSON(value?: PublicFailureTypeVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(PublicFailureTypeVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


